module.exports = __webpack_public_path__ + "img/164.5e59f232.jpg";